import React, { useState } from 'react';
import { Editor, EditorContent, useEditor } from '@tiptap/react';
import Document from '@tiptap/extension-document';
import Paragraph from '@tiptap/extension-paragraph';
import Text from '@tiptap/extension-text';
import { JSONContent } from '@tiptap/react';
import { Button } from '../../../shared/ui';
import { IconMap } from '../../../shared/sprite';

type CommentsEditorProps = {
  isEditable?: boolean;
  initialValue?: JSONContent;
  onSubmit: (content: JSONContent) => void;
  onCancel: () => void;
  disabled?: boolean;
};

export const CommentsEditorForm: React.FC<CommentsEditorProps> = ({
  isEditable = false,
  onSubmit,
  onCancel,
  initialValue,
  disabled = false,
}) => {
  const [commentText, setCommentText] = useState<JSONContent | null>(null);
  const [isEmpty, setIsEmpty] = useState<boolean>(true);
  const handleUpdate = ({ editor }: { editor: Editor }) => {
    setCommentText(editor.getJSON());
    setIsEmpty(editor.isEmpty);
  };

  const handleSubmit = () => {
    if (!commentText) return;
    onSubmit(commentText);
  };

  const handleCancel = () => {
    onCancel();
  };

  const editor = useEditor({
    content: initialValue,
    extensions: [Document, Paragraph, Text],
    autofocus: true,
    editorProps: {
      attributes: {
        class:
          'minimal-inline w-full px-3 py-2 overflow-y-auto border border-gray-300 rounded-lg max-h-40 focus:border-primary-600',
      },
    },
    onUpdate: handleUpdate,
    onCreate: ({ editor }) => {
      // Focus at the end when editor is created
      editor.commands.focus('end');
    },
  });
  return (
    <form className="flex flex-col gap-3">
      <div className="bg-base-white rounded-lg">
        <EditorContent editor={editor} />
      </div>
      <div className="flex items-center justify-between">
        <div>
          {/*TODO: mentions, reaction will be added in the next release*/}
        </div>
        <div className="flex items-center gap-2">
          <Button
            disabled={disabled}
            variant="text"
            color="transparent"
            size="sm"
            onClick={handleCancel}
          >
            Cancel
          </Button>
          <Button
            loading={disabled}
            disabled={isEmpty}
            variant={isEditable ? 'text' : 'icon-text'}
            iconLeftName={IconMap.Send03}
            color="primary"
            size="sm"
            onClick={handleSubmit}
          >
            {isEditable ? 'Save' : 'Send'}
          </Button>
        </div>
      </div>
    </form>
  );
};
